/**
 * Display status for a game row.
 *
 * `games.status` can be "cancelled" (and possibly "postponed") while still
 * carrying scores, so the score alone is not enough to call a game played.
 * Returns: "played" | "unplayed" | "cancelled" | "postponed".
 */
export function matchStatus(game) {
  const raw = String(game?.status || "").toLowerCase();
  if (raw === "cancelled" || raw === "canceled") return "cancelled";
  if (raw === "postponed") return "postponed";

  const hasScore =
    game?.team1_score !== null &&
    game?.team1_score !== undefined &&
    game?.team2_score !== null &&
    game?.team2_score !== undefined;

  return hasScore ? "played" : "unplayed";
}

export const STATUS_LABELS = {
  played: "Final",
  unplayed: "Programado",
  cancelled: "Cancelado",
  postponed: "Pospuesto",
};

/** Known finals round order; anything unknown sorts after, alphabetically. */
const ROUND_ORDER = [
  "dieciseisavos",
  "octavos",
  "cuartos",
  "quarter",
  "quarters",
  "semi",
  "semis",
  "semifinal",
  "semifinales",
  "tercer lugar",
  "3er lugar",
  "final",
  "finales",
];

export function roundRank(name) {
  const key = String(name || "").trim().toLowerCase();
  const idx = ROUND_ORDER.indexOf(key);
  return idx === -1 ? ROUND_ORDER.length : idx;
}

export function sortRounds(rounds) {
  return [...rounds].sort(
    (a, b) =>
      roundRank(a) - roundRank(b) ||
      String(a || "").localeCompare(String(b || ""), "es")
  );
}
